export interface Movie {
  id: number;
  title: string;
  engTitle: string;
  year: number;
  category: string;
  categorySlug: string;
  rating: number;
  duration: string;
  director: string;
  actors: string[];
  description: string;
  longDescription: string;
  poster: string;
  banner: string;
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
  tags: string[];
  region: string;
  releaseDate: string;
}

export const categories = [
  { name: '动作片', slug: 'action', icon: 'ri-sword-line' },
  { name: '喜剧片', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { name: '科幻片', slug: 'scifi', icon: 'ri-rocket-line' },
  { name: '经典电影', slug: 'classic', icon: 'ri-film-line' },
  { name: '爱情片', slug: 'romance', icon: 'ri-heart-line' },
  { name: '恐怖片', slug: 'horror', icon: 'ri-ghost-line' },
  { name: '动画片', slug: 'animation', icon: 'ri-magic-line' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-camera-line' },
];

export const movies: Movie[] = [
  {
    id: 1,
    title: '暗影追踪',
    engTitle: 'Shadow Chase',
    year: 2026,
    category: '动作片',
    categorySlug: 'action',
    rating: 8.7,
    duration: '128分钟',
    director: '陈凯峰',
    actors: ['刘德华', '吴京', '张涵予', '周迅'],
    description: '一名退役特种兵深入敌后，为保护国家机密与跨国犯罪集团展开殊死搏斗。',
    longDescription: '前特种部队成员林峰在一次任务中负伤退役，本以为可以过上平静的生活。然而，一个神秘组织窃取了国家级机密，林峰被紧急召回，不得不再次踏上战场。从繁华都市到戈壁荒漠，从地下基地到海上平台，林峰与时间赛跑，与敌人周旋。在这场没有硝烟的战争中，他不仅要面对强大的敌人，还要直面内心的恐惧与挣扎。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20action%20movie%20poster%20with%20soldier%20in%20tactical%20gear%20urban%20night%20scene%20dramatic%20lighting%20warm%20gold%20and%20dark%20tones%20cinematic%20composition%20professional%20film%20poster%20style&width=600&height=900&seq=movie-poster-01&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20action%20movie%20scene%20soldier%20running%20through%20city%20at%20night%20explosions%20in%20background%20warm%20golden%20and%20dark%20cinematic%20lighting%20high%20contrast%20dramatic%20atmosphere%20film%20grain%20texture&width=1600&height=700&seq=movie-banner-01&orientation=landscape',
    isHot: true,
    isNew: true,
    isRecommended: true,
    tags: ['动作', '特工', '悬疑', '军事'],
    region: '中国大陆',
    releaseDate: '2026-07-15',
  },
  {
    id: 2,
    title: '笑傲江湖之喜剧之王',
    engTitle: 'King of Comedy: Swordsman',
    year: 2026,
    category: '喜剧片',
    categorySlug: 'comedy',
    rating: 8.4,
    duration: '115分钟',
    director: '周星驰',
    actors: ['沈腾', '马丽', '艾伦', '贾玲'],
    description: '一个普通小人物阴差阳错卷入江湖纷争，用幽默和智慧化解重重危机。',
    longDescription: '平凡的外卖员阿星在一次送餐途中，意外获得了一本传说中的武功秘籍。正当他以为人生即将改变时，却发现这本秘籍其实是一本搞笑段子合集。无奈之下，阿星只好用自己与生俱来的幽默感和机智，在真正的武林高手面前虚张声势。没想到他的"喜剧武功"竟然出奇制胜，不仅赢得了美人的芳心，还意外成为了新一代的武林盟主。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%20colorful%20playful%20design%20man%20in%20ancient%20Chinese%20costume%20making%20funny%20face%20bright%20warm%20colors%20golden%20and%20red%20tones%20professional%20film%20poster%20style&width=600&height=900&seq=movie-poster-02&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20Chinese%20comedy%20film%20scene%20ancient%20Chinese%20marketplace%20crowd%20laughing%20festive%20atmosphere%20warm%20golden%20sunlight%20cinematic%20lighting%20cheerful%20mood&width=1600&height=700&seq=movie-banner-02&orientation=landscape',
    isHot: true,
    isNew: false,
    isRecommended: true,
    tags: ['喜剧', '古装', '武侠', '搞笑'],
    region: '中国大陆',
    releaseDate: '2026-06-20',
  },
  {
    id: 3,
    title: '星际迷途：新纪元',
    engTitle: 'Star Trek: New Era',
    year: 2026,
    category: '科幻片',
    categorySlug: 'scifi',
    rating: 9.1,
    duration: '152分钟',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '赵今麦'],
    description: '人类在探索外太空时发现了神秘文明遗迹，一场关乎地球存亡的星际冒险就此展开。',
    longDescription: '公元2150年，人类在火星轨道发现了一艘外星飞船的残骸。科学家们在残骸中破译出了一条信息——一个来自遥远星系的高级文明正在向地球发出警告。为了人类的未来，由精英宇航员组成的探索队踏上了前往未知星系的旅程。在那里，他们发现了令人震撼的真相：宇宙中存在着一个古老的星际联盟，而地球正面临着一场前所未有的考验。',
    poster: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20sci-fi%20movie%20poster%20astronaut%20floating%20in%20space%20nebula%20background%20warm%20orange%20and%20deep%20black%20contrast%20cinematic%20composition%20professional%20film%20poster%20style&width=600&height=900&seq=movie-poster-03&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20scene%20spaceship%20approaching%20alien%20planet%20nebula%20colors%20warm%20orange%20and%20deep%20purple%20cinematic%20lighting%20grand%20scale%20atmosphere&width=1600&height=700&seq=movie-banner-03&orientation=landscape',
    isHot: true,
    isNew: true,
    isRecommended: true,
    tags: ['科幻', '太空', '冒险', '灾难'],
    region: '中国大陆',
    releaseDate: '2026-07-01',
  },
  {
    id: 4,
    title: '霸王别姬（4K修复版）',
    engTitle: 'Farewell My Concubine (4K)',
    year: 1993,
    category: '经典电影',
    categorySlug: 'classic',
    rating: 9.6,
    duration: '171分钟',
    director: '陈凯歌',
    actors: ['张国荣', '巩俐', '张丰毅', '葛优'],
    description: '两个京剧伶人跨越半个世纪的悲欢离合，一部关于艺术、爱情与时代的史诗巨作。',
    longDescription: '故事从1924年的北京开始，讲述了小豆子和小石头两个被送入京剧科班的孩子，从此开始了他们坎坷又传奇的一生。小豆子被选为旦角，小石头成为武生，两人在舞台上配合天衣无缝，尤其是《霸王别姬》一折更是誉满京城。然而在动荡的时代背景下，他们的命运也如戏剧般跌宕起伏。这部影片不仅是两个艺人的故事，更是中国近现代历史的缩影，深刻展现了人性在时代洪流中的挣扎与坚守。',
    poster: 'https://readdy.ai/api/search-image?query=Classic%20Chinese%20film%20poster%20Peking%20opera%20actor%20in%20elaborate%20costume%20and%20makeup%20dramatic%20expression%20warm%20golden%20and%20deep%20red%20tones%20vintage%20cinematic%20style%20artistic%20composition&width=600&height=900&seq=movie-poster-04&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20Peking%20opera%20stage%20performance%20elaborate%20costumes%20dramatic%20lighting%20warm%20golden%20and%20red%20tones%20theatrical%20atmosphere%20cinematic%20composition&width=1600&height=700&seq=movie-banner-04&orientation=landscape',
    isHot: false,
    isNew: false,
    isRecommended: true,
    tags: ['经典', '剧情', '历史', '京剧'],
    region: '中国大陆',
    releaseDate: '1993-01-01',
  },
  {
    id: 5,
    title: '午夜追踪',
    engTitle: 'Midnight Pursuit',
    year: 2026,
    category: '动作片',
    categorySlug: 'action',
    rating: 7.9,
    duration: '118分钟',
    director: '林超贤',
    actors: ['彭于晏', '张译', '王千源', '黄景瑜'],
    description: '缉毒警察深入金三角腹地，与毒贩展开一场惊心动魄的生死追逐。',
    longDescription: '缉毒队长陈飞接到线报，一个大型贩毒集团正在策划一次史无前例的毒品交易。为了不打草惊蛇，陈飞带领小队伪装成买家，深入金三角腹地。然而事情远比想象中复杂，内部出现了卧底，交易现场变成了生死战场。在枪林弹雨中，陈飞和他的队友们用生命守护着正义的底线。',
    poster: 'https://readdy.ai/api/search-image?query=Intense%20Chinese%20action%20thriller%20movie%20poster%20police%20officer%20holding%20gun%20jungle%20background%20warm%20amber%20and%20dark%20green%20tones%20cinematic%20composition%20professional%20film%20poster&width=600&height=900&seq=movie-poster-05&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Intense%20jungle%20action%20scene%20police%20teams%20in%20tactical%20gear%20running%20through%20dense%20tropical%20forest%20dramatic%20warm%20lighting%20through%20trees%20cinematic%20atmosphere&width=1600&height=700&seq=movie-banner-05&orientation=landscape',
    isHot: false,
    isNew: true,
    isRecommended: false,
    tags: ['动作', '警匪', '缉毒', '枪战'],
    region: '中国香港',
    releaseDate: '2026-05-30',
  },
  {
    id: 6,
    title: '疯狂动物园',
    engTitle: 'Crazy Zoo',
    year: 2026,
    category: '喜剧片',
    categorySlug: 'comedy',
    rating: 7.8,
    duration: '102分钟',
    director: '闫非',
    actors: ['沈腾', '魏翔', '常远', '王智'],
    description: '一群性格各异的动物管理员与聪明动物们之间发生的爆笑故事。',
    longDescription: '阳光动物园面临倒闭危机，园长决定举办一场史无前例的动物表演来拯救动物园。然而，园里的动物们似乎都有自己的想法——会偷吃零食的大熊猫、喜欢恶作剧的猴子、还有一只有"社交恐惧症"的老虎。管理员们必须在最短的时间内让这些"问题动物"乖乖听话，但这显然不是一件容易的事。',
    poster: 'https://readdy.ai/api/search-image?query=Funny%20Chinese%20comedy%20movie%20poster%20zookeeper%20surrounded%20by%20cartoonish%20animals%20colorful%20playful%20design%20warm%20bright%20colors%20professional%20film%20poster%20style&width=600&height=900&seq=movie-poster-06&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Colorful%20fun%20zoo%20scene%20Chinese%20comedy%20film%20animals%20and%20people%20interacting%20playfully%20bright%20sunny%20day%20warm%20golden%20lighting%20cheerful%20atmosphere&width=1600&height=700&seq=movie-banner-06&orientation=landscape',
    isHot: false,
    isNew: true,
    isRecommended: false,
    tags: ['喜剧', '动物', '家庭', '搞笑'],
    region: '中国大陆',
    releaseDate: '2026-06-01',
  },
  {
    id: 7,
    title: '超时空救援',
    engTitle: 'Time Rescue',
    year: 2025,
    category: '科幻片',
    categorySlug: 'scifi',
    rating: 8.2,
    duration: '135分钟',
    director: '路阳',
    actors: ['雷佳音', '杨幂', '董子健', '于和伟'],
    description: '科学家发明了时空穿梭装置，为拯救世界而展开跨越时空的救援行动。',
    longDescription: '2040年，地球资源枯竭，人类面临生存危机。天才物理学家陈默研究出了一种时空穿梭装置，可以让人回到过去的关键时间节点。然而，每一次的时空旅行都会对现在产生不可预知的蝴蝶效应。陈默必须在有限的时间内找到最优解，同时还要应对来自各方势力的阻挠。这是一场与时间的赛跑，也是一次对人性的终极考验。',
    poster: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20sci-fi%20movie%20poster%20time%20travel%20portal%20with%20scientist%20stepping%20through%20warm%20orange%20and%20electric%20blue%20energy%20cinematic%20composition%20professional%20film%20poster&width=600&height=900&seq=movie-poster-07&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Futuristic%20laboratory%20with%20time%20portal%20energy%20rings%20scientists%20working%20dramatic%20warm%20orange%20and%20cool%20blue%20lighting%20cinematic%20atmosphere%20grand%20scale&width=1600&height=700&seq=movie-banner-07&orientation=landscape',
    isHot: false,
    isNew: false,
    isRecommended: true,
    tags: ['科幻', '时空', '冒险', '悬疑'],
    region: '中国大陆',
    releaseDate: '2025-12-20',
  },
  {
    id: 8,
    title: '罗马假日（重映）',
    engTitle: 'Roman Holiday (Re-release)',
    year: 1953,
    category: '经典电影',
    categorySlug: 'classic',
    rating: 9.3,
    duration: '118分钟',
    director: '威廉·惠勒',
    actors: ['奥黛丽·赫本', '格利高里·派克'],
    description: '一位欧洲公主与美国记者在罗马的一天浪漫邂逅，永恒的银幕经典。',
    longDescription: '安妮公主作为王室继承人，在欧洲进行巡回访问。在罗马的最后一站，繁重的外交行程让她感到窒息。一天深夜，她偷偷溜出了大使馆，却在街头遇到了美国记者乔·布莱德利。乔认出了公主的身份，本想借此机会获取独家新闻，却在一天的相处中，被公主的纯真和美丽深深打动。两人在罗马的街头巷尾留下了最美好的回忆，但现实的鸿沟终究难以跨越。',
    poster: 'https://readdy.ai/api/search-image?query=Classic%20black%20and%20white%20Roman%20Holiday%20movie%20poster%20style%20elegant%20woman%20on%20vespa%20in%20Rome%20vintage%20cinematic%20style%20warm%20sepia%20tones%20artistic%20composition&width=600&height=900&seq=movie-poster-08&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Classic%20Rome%20cityscape%20vintage%20style%20vespa%20on%20cobblestone%20street%20warm%20sepia%20golden%20hour%20lighting%20romantic%20atmosphere%20cinematic%20composition&width=1600&height=700&seq=movie-banner-08&orientation=landscape',
    isHot: false,
    isNew: false,
    isRecommended: false,
    tags: ['经典', '爱情', '浪漫', '文艺'],
    region: '美国',
    releaseDate: '1953-08-27',
  },
  {
    id: 9,
    title: '爱情呼叫转移',
    engTitle: 'Love Transfer',
    year: 2025,
    category: '爱情片',
    categorySlug: 'romance',
    rating: 8.0,
    duration: '110分钟',
    director: '张一白',
    actors: ['刘昊然', '周冬雨', '易烊千玺', '张子枫'],
    description: '三个年轻人在繁华都市中相遇、错过、重逢的爱情故事。',
    longDescription: '在北京这座繁忙的都市中，三个年轻人的命运被一条看不见的线连接在一起。林悦是一位热爱摄影的女孩，赵阳是一名创业青年，而小七则是一位自由音乐人。他们在不同的时间、不同的地点相遇，每一次的擦肩而过都让彼此的人生轨迹发生了微妙的变化。当城市的地铁将他们再次聚在一起时，那些未说出口的话和未曾表达的真心，终于有了释放的机会。',
    poster: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20movie%20poster%20young%20couple%20in%20modern%20city%20at%20sunset%20warm%20pink%20and%20golden%20tones%20soft%20lighting%20cinematic%20composition%20professional%20film%20poster&width=600&height=900&seq=movie-poster-09&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Romantic%20cityscape%20at%20sunset%20young%20couple%20walking%20on%20modern%20bridge%20warm%20golden%20pink%20sky%20soft%20cinematic%20lighting%20emotional%20atmosphere&width=1600&height=700&seq=movie-banner-09&orientation=landscape',
    isHot: false,
    isNew: false,
    isRecommended: true,
    tags: ['爱情', '都市', '青春', '文艺'],
    region: '中国大陆',
    releaseDate: '2025-08-25',
  },
  {
    id: 10,
    title: '诡宅',
    engTitle: 'The Haunted Mansion',
    year: 2026,
    category: '恐怖片',
    categorySlug: 'horror',
    rating: 7.5,
    duration: '105分钟',
    director: '温子仁',
    actors: ['张震', '舒淇', '彭于晏', '刘亦菲'],
    description: '一家人搬进一座古老大宅后，接二连三遭遇诡异事件，揭开了一段尘封的黑暗往事。',
    longDescription: '沈家一家人因为父亲的工作调动，搬进了一座位于郊区的古老宅邸。这座大宅有着上百年的历史，外观庄严宏伟，价格却出奇地便宜。入住后的第一个夜晚，怪事便开始发生——走廊里传来小孩的哭声、镜子中倒映出不属于这个时代的影像、地下室的门总会在午夜自动打开。随着调查的深入，沈家人发现，这座宅邸曾经发生了一桩骇人听闻的惨案。',
    poster: 'https://readdy.ai/api/search-image?query=Horror%20Chinese%20movie%20poster%20dark%20haunted%20mansion%20with%20ghostly%20figure%20in%20window%20eerie%20warm%20amber%20and%20deep%20shadow%20tones%20cinematic%20composition%20professional%20film%20poster&width=600&height=900&seq=movie-poster-10&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Eerie%20old%20Chinese%20mansion%20at%20night%20foggy%20garden%20warm%20flickering%20candle%20light%20through%20windows%20dark%20mysterious%20atmosphere%20cinematic%20horror%20composition&width=1600&height=700&seq=movie-banner-10&orientation=landscape',
    isHot: false,
    isNew: true,
    isRecommended: false,
    tags: ['恐怖', '悬疑', '惊悚', '灵异'],
    region: '中国台湾',
    releaseDate: '2026-04-18',
  },
  {
    id: 11,
    title: '龙神传说',
    engTitle: 'Legend of the Dragon',
    year: 2026,
    category: '动画片',
    categorySlug: 'animation',
    rating: 8.5,
    duration: '98分钟',
    director: '饺子',
    actors: ['杨天翔', '张杰', '季冠霖', '乔诗语'],
    description: '一个平凡少年意外获得龙神之力，踏上了拯救苍生的冒险旅程。',
    longDescription: '在一个古老而神秘的东方世界，少年阿龙生活在海边的一个小渔村。一天，他在海边救下了一条受伤的小龙，却不知这条小龙正是龙神的化身。为了报答阿龙的救命之恩，龙神将一部分神力赐予了他。从此，阿龙拥有了控制水元素的能力。然而，黑暗势力也在蠢蠢欲动，他们想要夺取龙神的力量来统治世界。阿龙必须肩负起守护世界的重任。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%20mythical%20dragon%20with%20young%20hero%20standing%20on%20cliff%20warm%20golden%20and%20jade%20green%20tones%20epic%20cinematic%20composition%20professional%20film%20poster&width=600&height=900&seq=movie-poster-11&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythology%20animation%20scene%20giant%20dragon%20flying%20over%20ancient%20Chinese%20landscape%20mountains%20and%20clouds%20warm%20golden%20sunlight%20cinematic%20grand%20atmosphere&width=1600&height=700&seq=movie-banner-11&orientation=landscape',
    isHot: true,
    isNew: true,
    isRecommended: true,
    tags: ['动画', '神话', '冒险', '奇幻'],
    region: '中国大陆',
    releaseDate: '2026-07-08',
  },
  {
    id: 12,
    title: '地球脉动：中国篇',
    engTitle: 'Planet Earth: China',
    year: 2025,
    category: '纪录片',
    categorySlug: 'documentary',
    rating: 9.4,
    duration: '95分钟',
    director: '陆川',
    actors: ['周迅'],
    description: '以震撼的镜头记录中国大地上壮美的自然景观与珍稀的野生动植物。',
    longDescription: '从青藏高原的雪域冰川到海南岛的热带雨林，从东北的茫茫林海到西南的喀斯特地貌，《地球脉动：中国篇》用最先进的摄影技术，捕捉到了中国大地上最令人叹为观止的自然奇观。影片历时三年拍摄，跨越了中国全部34个省级行政区，记录了大熊猫、藏羚羊、丹顶鹤等珍稀动物的真实生活状态，展现了人与自然和谐共生的壮丽画卷。',
    poster: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20movie%20poster%20Chinese%20landscape%20giant%20panda%20in%20bamboo%20forest%20warm%20natural%20lighting%20earthy%20green%20and%20golden%20tones%20cinematic%20composition&width=600&height=900&seq=movie-poster-12&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20Chinese%20landscape%20mountains%20rivers%20bamboo%20forests%20wildlife%20golden%20hour%20natural%20lighting%20epic%20cinematic%20documentary%20style&width=1600&height=700&seq=movie-banner-12&orientation=landscape',
    isHot: false,
    isNew: false,
    isRecommended: false,
    tags: ['纪录片', '自然', '动物', '地理'],
    region: '中国大陆',
    releaseDate: '2025-10-01',
  },
];

export const hotMovies = movies.filter(m => m.isHot);
export const newMovies = movies.filter(m => m.isNew);
export const recommendedMovies = movies.filter(m => m.isRecommended);
export const topRatedMovies = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 10);